module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/appModalCrumbsView.html -->\n<div class="mdc-tab-bar" role="tablist">\n	<div class="mdc-tab-scroller">\n		<div class="mdc-tab-scroller__scroll-area">\n			<div class="mdc-tab-scroller__scroll-content nx-childviews"></div>\n		</div>\n	</div>\n</div>';
}
return __p;
};
